@if (details.length) {
	<div class="item-list">
		@for (item of details; track item) {
			<div class="item">
				<div class="content">
					<div class="header" data-test="medication-name-item">
						{{ item.medication.description ?? item.medication.name | language }}
					</div>
					@if (item.quantity) {
						<ul>
							<li data-test="quantity-item">
								{{ "medication.found_medication_incidents.steps.details.quantity" | translate }}: {{ item.quantity }}
							</li>
						</ul>
					}
				</div>
				<div class="actions">
					<button class="button" data-test="remove-medication-button" (click)="onDelete(item)">
						<i class="fa fa-trash"></i>
					</button>
				</div>
			</div>
		}
	</div>
} @else {
	<div class="empty-list" data-test="empty-list" [class.error]="touched">
		{{ "medication.add_medication.empty" | translate }}
	</div>
}
